(() => {
  if (window.__cityOpticalPdpBound) return;
  window.__cityOpticalPdpBound = true;

  document.addEventListener('toggle', (event) => {
    const details = event.target;
    if (details.matches?.('[data-optical-temple-helper]')) details.querySelector(':scope > summary')?.setAttribute('aria-expanded', String(details.open));
  }, true);

  document.addEventListener('click', (event) => {
    const vtoTrigger = event.target.closest('[data-optical-vto-open]');
    if (vtoTrigger) {
      const owner = vtoTrigger.closest('[data-optical-vto-variants]');
      const sectionId = owner?.dataset.sectionId;
      const productHandle = owner?.dataset.productHandle;
      let candidates = [];
      if (sectionId) {
        candidates = [...document.querySelectorAll(`[data-vto-external-open][data-vto-section-id="${CSS.escape(sectionId)}"]`)];
        const sectionVto = document.querySelector(`city-virtual-try-on[data-section-id="${CSS.escape(sectionId)}"]`);
        if (sectionVto) candidates.push(...sectionVto.querySelectorAll('[data-vto-external-open], [data-vto-open]'));
      }
      if (!candidates.length && productHandle) {
        const productVto = document.querySelector(`city-virtual-try-on[data-product-handle="${CSS.escape(productHandle)}"]`);
        if (productVto) {
          const productSectionId = productVto.dataset.sectionId;
          if (productSectionId) {
            candidates = [...document.querySelectorAll(`[data-vto-external-open][data-vto-section-id="${CSS.escape(productSectionId)}"]`)];
          }
          candidates.push(...productVto.querySelectorAll('[data-vto-external-open], [data-vto-open]'));
        }
      }
      const button = candidates.find((candidate) => {
        const rect = candidate.getBoundingClientRect();
        return !candidate.hidden && getComputedStyle(candidate).display !== 'none' && rect.width > 0 && rect.height > 0;
      });
      if (button) {
        event.preventDefault();
        button.click();
      }
      return;
    }

    const prescriptionTrigger = event.target.closest('[data-optical-prescription-launch]');
    const compareTrigger = event.target.closest('[data-optical-compare-open]');
    if (compareTrigger) {
      const details = document.querySelector('[id^="OpticalDetails-"]');
      const summary = details?.querySelector('summary');
      if (!details || !summary) return;
      event.preventDefault();
      details.open = true;
      summary.setAttribute('aria-expanded', 'true');
      summary.scrollIntoView({ behavior: 'smooth', block: 'center' });
      window.setTimeout(() => summary.focus({ preventScroll: true }), 450);
      return;
    }

    if (!prescriptionTrigger) return;
    const button = document.querySelector('[data-optical-prescription-open]');
    if (!button) return;
    event.preventDefault();
    button.click();
    button.scrollIntoView({ behavior: 'smooth', block: 'center' });
    window.setTimeout(() => button.focus({ preventScroll: true }), 450);
  });

  const syncOpticalMobileGallery = (variant, sectionId) => {
    const mediaId = variant?.featured_media?.id || variant?.featured_media_id;
    if (!mediaId) return;
    const galleries = sectionId
      ? document.querySelectorAll(`[data-optical-mobile-gallery][data-section-id="${CSS.escape(String(sectionId))}"]`)
      : document.querySelectorAll('[data-optical-mobile-gallery]');
    galleries.forEach((gallery) => {
      const item = gallery.querySelector(`[data-optical-media-id="${CSS.escape(String(mediaId))}"]`);
      if (!item) return;
      gallery.scrollTo({ left: item.offsetLeft, behavior: 'smooth' });
    });
  };

  const normaliseMediaText = (value) => String(value || '')
    .toLowerCase()
    .replace(/[\u2012\u2013\u2014\u2015]/g, ' - ')
    .replace(/\s+/g, ' ')
    .trim();

  const syncSafeStyleMedia = (variant) => {
    const root = document.querySelector('.product--safestyle-prescription[data-safestyle-colour]');
    if (!root) return;
    const colour = variant?.option1 || variant?.options?.[0] || root.dataset.safestyleColour;
    if (!colour) return;
    root.dataset.safestyleColour = colour;
    document.querySelectorAll('[data-safestyle-current-colour]').forEach((node) => { node.textContent = colour; });
    const colourToken = ` in ${normaliseMediaText(colour)} - `;
    root.querySelectorAll('[data-media-alt], .MagicToolboxSelectorsContainer a.mz-thumb').forEach((item) => {
      const alt = normaliseMediaText(item.dataset.mediaAlt || item.querySelector('img')?.alt || item.title);
      const isSafeStyleColourMedia = alt.includes('safestyle ') && alt.includes(' in ') && alt.includes(' - ');
      const shouldHide = isSafeStyleColourMedia && !alt.includes(colourToken);
      item.hidden = shouldHide;
      item.classList.toggle('safestyle-media-hidden', shouldHide);
    });
    document.querySelectorAll('[data-safestyle-fit-side]').forEach((item) => {
      const alt = normaliseMediaText(item.dataset.mediaAlt || item.querySelector('img')?.alt);
      const shouldHide = !alt.includes(colourToken);
      item.hidden = shouldHide;
      item.classList.toggle('safestyle-media-hidden', shouldHide);
    });
    if (root.dataset.safestyleMediaObserved !== 'true') {
      root.dataset.safestyleMediaObserved = 'true';
      const mediaWrapper = root.querySelector('.product__media-wrapper') || root;
      new MutationObserver(() => syncSafeStyleMedia()).observe(mediaWrapper, { childList: true, subtree: true });
    }
  };

  const syncOpticalVtoActions = (variant, sectionId) => {
    if (!variant?.id) return;
    const selectedToken = `|${variant.id}|`;
    const sectionVto = sectionId
      ? document.querySelector(`city-virtual-try-on[data-section-id="${CSS.escape(String(sectionId))}"]`)
      : null;
    const productHandle = sectionVto?.dataset.productHandle;
    let roots = [];
    if (productHandle) {
      roots = [...document.querySelectorAll(`[data-optical-vto-variants][data-product-handle="${CSS.escape(productHandle)}"]`)];
    } else if (sectionId) {
      roots = [...document.querySelectorAll(`[data-optical-vto-variants][data-section-id="${CSS.escape(String(sectionId))}"]`)];
    }
    roots.forEach((root) => {
      const isEnabled = (root.dataset.opticalVtoVariants || '').includes(selectedToken);
      root.querySelectorAll('[data-optical-vto-open]').forEach((button) => { button.hidden = !isEnabled; });
      root.querySelectorAll('[data-optical-vto-fallback]').forEach((link) => { link.hidden = isEnabled; });
    });
  };

  document.addEventListener('change', (event) => {
    if (!event.target.matches('.product--safestyle-prescription .product-form__input input[type="radio"]')) return;
    syncSafeStyleMedia({ option1: event.target.value });
  });

  const syncOpticalFitGuide = (variant, picker) => {
    if (!variant?.id || !picker) return;
    document.querySelectorAll('[data-optical-fit-guide]').forEach(async (guide) => {
      if (guide.dataset.productUrl !== picker.dataset.url) return;
      const requestedId = String(variant.id);
      guide.dataset.opticalRequestedVariant = requestedId;
      try {
        const url = new URL(guide.dataset.productUrl, window.location.origin);
        url.searchParams.set('variant', requestedId);
        url.searchParams.set('section_id', guide.dataset.sectionId);
        const response = await fetch(url);
        if (!response.ok) throw new Error(`Fit section response ${response.status}`);
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const source = html.querySelector('[data-optical-fit-guide]');
        if (guide.dataset.opticalRequestedVariant !== requestedId || !source) return;
        guide.innerHTML = source.innerHTML;
      } catch (error) {
        console.warn('Selected-size fit guide could not be refreshed.', error);
      }
    });
  };

  const sizedPicker = document.querySelector('variant-selects[data-city-optical-size-index]');
  if (sizedPicker && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      const variant = event?.data?.variant;
      const sectionId = event?.data?.sectionId;
      if (String(sectionId) !== String(sizedPicker.dataset.section)) return;
      if (event?.data?.html && sectionId) {
        const destination = document.getElementById(`OpticalDetailsPanel-${sectionId}`);
        const source = event.data.html.getElementById(`OpticalDetailsPanel-${sectionId}`);
        if (destination?.hasAttribute('data-optical-variant-specs') && source) destination.innerHTML = source.innerHTML;
      }
      syncOpticalFitGuide(variant, sizedPicker);
      syncOpticalMobileGallery(variant, sectionId);
      syncSafeStyleMedia(variant);
      syncOpticalVtoActions(variant, sectionId);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => syncSafeStyleMedia(), { once: true });
  } else {
    syncSafeStyleMedia();
  }
})();
